export default `<g fill="currentColor"><path d="M11.9,0.9c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S18.1,0.9,11.9,0.9z M13.5,16.3c0,0.9-0.6,1.6-1.6,1.6
s-1.6-0.6-1.6-1.6v-4.4c0-0.9,0.6-1.6,1.6-1.6s1.6,0.6,1.6,1.6V16.3z M11.9,8.8c-0.9,0-1.6-0.6-1.6-1.6s0.6-1.6,1.6-1.6
s1.6,0.6,1.6,1.6S12.9,8.8,11.9,8.8z"/></g>`;
